import React from 'react';
import Wrapper from '../assets/wrappers/Navbar';
import { FaAlignLeft, FaUserCircle, FaCaretDown } from 'react-icons/fa';
import { useState } from 'react';
import { useEthers } from '@usedapp/core';

import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar, disconnect } from '../features/user/userSlice';
import { shortenAddress } from '@usedapp/core';

const Navbar = () => {
  const [showLogout, setShowLogout] = useState(false);
  const { activateBrowserWallet } = useEthers();
  const { connected, connectedAccount } = useSelector((store) => store.user);

  const dispatch = useDispatch();

  const toggle = () => {
    dispatch(toggleSidebar());
  };

  return (
    <Wrapper>
      <div className='nav-center'>
        <button type='button' className='toggle-btn' onClick={toggle}>
          <FaAlignLeft />
        </button>
        <div className='btn-container'>
          {connected && (
            <>
              <button
                type='button'
                className='btn'
                onClick={() => setShowLogout(!showLogout)}
              >
                <FaUserCircle />
                {shortenAddress(connectedAccount)}
                <FaCaretDown />
              </button>
              <div
                className={showLogout ? 'dropdown show-dropdown' : 'dropdown'}
              >
                <button
                  type='button'
                  className='dropdown-btn'
                  onClick={() => dispatch(disconnect())}
                >
                  Disconnect
                </button>
              </div>
            </>
          )}
          {!connected && (
            <button
              className='btn'
              variant='outlined'
              onClick={() => activateBrowserWallet()}
            >
              Connect
            </button>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default Navbar;
